var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feather-icon',{attrs:{"icon":_vm.icon,"size":"16"}})}
var staticRenderFns = []

export { render, staticRenderFns }